import { Color, FontSize, FontWeight, LineHeight } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReviewEntryDetailNavHeaderRoot = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: space-between;
`

export const NavCounter = styled.span`
  color: ${Color.Grey400};
  font-size: ${FontSize.TextBodyLG};
  font-weight: ${FontWeight.Medium};
  line-height: ${LineHeight.TextBodyLG};
  white-space: nowrap;
`
